import { render, staticRenderFns } from "./AnalysisItems.vue?vue&type=template&id=02470771&"
import script from "./AnalysisItems.vue?vue&type=script&lang=js&"
export * from "./AnalysisItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports